import { render, staticRenderFns } from "./card-header.vue?vue&type=template&id=40bb9b2d"
import script from "./card-header.vue?vue&type=script&lang=js"
export * from "./card-header.vue?vue&type=script&lang=js"
import style0 from "./card-header.vue?vue&type=style&index=0&id=40bb9b2d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports